const { name } = require('../helpers/env.js');
const hasOpenTokSupport = require('./hasOpenTokSupport.js').once;

module.exports = () => hasOpenTokSupport() && ['Chrome', 'Firefox', 'Safari'].indexOf(name) > -1;
